import styled from '@emotion/styled'
import { breakpoint, calcRem, metrics } from '../__styling'

export const StyledUserSetting = styled.div(({ theme }) => [
    {
        fontFamily: theme.fonts.sansSerif,
        padding: calcRem(0, metrics.thenightly.margins.m2l),
        display: 'flex',
        overflow: 'hidden',
        maxWidth: theme.siteMetrics.mainContentWidth,
        margin: '0 auto',

        [breakpoint('lg')]: {
            padding: 0,
        },
    },
    // PerthNow styling
    theme.kind === 'perthnow' && {
        padding: calcRem(32, 16),

        // Mobile or larger styling
        [breakpoint('sm')]: {
            padding: calcRem(24, 16),
            gap: calcRem(32),
        },
        // Large screens or bigger styling
        [breakpoint('lg')]: {
            padding: calcRem(24, 0),
        },
    },
])

export const StyledWrapper = styled.div({
    position: 'relative',
})
